module.exports = __webpack_public_path__ + "static/assets/ea952837ca442a3d64ab17637b787d36.png";